// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import Field from "../Field";
import {
  FieldPreview as StyledFieldPreview,
  ButtonLink,
  ExpandedField as StyledExpandedField,
  NestedFieldContainer
} from "./styles";
import ChecklistPreview from "./ChecklistPreview";
import Icon from "src/icons";

type Props = {
  fields: Array<number>,
  roomId: number,
  showFieldNames: boolean,
  expand: boolean,
  toggleExpand: Function
};

const NestedFields = ({
  fields,
  roomId,
  showFieldNames,
  expand,
  toggleExpand
}: Props) => {
  if (!expand) {
    return (
      <NestedFieldContainer>
        {showFieldNames && (
          <StyledFieldPreview>
            {fields.map((fieldId: number) => (
              <ChecklistPreview
                key={fieldId}
                fieldId={fieldId}
                roomId={roomId}
              />
            ))}
          </StyledFieldPreview>
        )}
        <ButtonLink
          data-cy="expandFieldButton"
          type="button"
          onClick={toggleExpand}
        >
          {i18n.t(k.VIEW_ALL_FIELDS)} <Icon type="down" />
        </ButtonLink>
      </NestedFieldContainer>
    );
  }
  return (
    <StyledExpandedField data-cy="expandedFields">
      {fields.map((fieldId: number) => (
        <Field key={fieldId} id={fieldId} roomId={`${roomId}`} />
      ))}
    </StyledExpandedField>
  );
};

export default NestedFields;
